import { render, staticRenderFns } from "./ChatLeft.vue?vue&type=template&id=60cb023e&scoped=true&"
import script from "./ChatLeft.vue?vue&type=script&lang=js&"
export * from "./ChatLeft.vue?vue&type=script&lang=js&"
import style0 from "./ChatLeft.vue?vue&type=style&index=0&id=60cb023e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cb023e",
  null
  
)

export default component.exports